module.exports = {
          srcSet: __webpack_public_path__ + "public/02fce8163e68ec36866f9e0dca55fbdd-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/02fce8163e68ec36866f9e0dca55fbdd-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/02fce8163e68ec36866f9e0dca55fbdd-80.png",
          toString:function(){return __webpack_public_path__ + "public/02fce8163e68ec36866f9e0dca55fbdd-80.png"},
          
          width: 80,
          height: 80
        }